/**
 * AS_CQ-D002 — borrower portal external links.
 *
 * Marketing pages live on qa.{env}.cliqloan.com / www.cliqloan.com — not legacy
 * kramasoft hosts or bare cliqloan.com/#page-0. Override per deploy via REACT_APP_*.
 */
export const aboutUsUrl =
  process.env.REACT_APP_ABOUT_US || "https://www.cliqloan.com/#about";

export const signInUrl =
  process.env.REACT_APP_SIGN_IN_URL || "https://app.cliqloan.com/signin";

export const supportUsersGuideUrl =
  process.env.REACT_APP_SUPPORT_USERS_GUIDE ||
  "https://support.cliqloan.com/support/usersguide";

export const socialLinks = {
  linkedIn: "https://www.linkedin.com/company/cliqloan/",
  facebook: "https://www.facebook.com/profile.php?id=61583493570024",
  x: "https://x.com/CliQloan2025",
};
